import { useState, useRef, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

export function AuthStatusBar() {
  const user = useAuthStore((s) => s.user)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const logout = useAuthStore((s) => s.logout)
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const navigate = useNavigate()
  const location = useLocation()

  // 로그인 페이지에서는 표시 안함
  if (location.pathname === '/login') return null

  if (!isAuthenticated || !user) {
    return (
      <div className="fixed top-3 right-3 z-50">
        <button
          onClick={() => navigate('/login')}
          className="px-4 py-2 text-sm text-white bg-blue-500 hover:bg-blue-600 rounded-full shadow-md transition-colors"
        >
          로그인
        </button>
      </div>
    )
  }

  const initial = user.displayName.charAt(0)

  return (
    <div ref={ref} className="fixed top-3 right-3 z-50">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-9 h-9 rounded-full bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium flex items-center justify-center transition-colors shadow-md"
      >
        {initial}
      </button>

      {open && (
        <div className="absolute top-11 right-0 w-48 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-sm font-medium text-gray-900">{user.displayName}</p>
            <p className="text-xs text-gray-500 mt-0.5">
              {user.source === 'LEGACY' ? '깨봉 온라인' : '깨봉 러닝센터'}
            </p>
          </div>
          <button
            onClick={() => { setOpen(false); logout() }}
            className="w-full px-4 py-2.5 text-left text-sm text-red-500 hover:bg-gray-50 transition-colors"
          >
            로그아웃
          </button>
        </div>
      )}
    </div>
  )
}
